import { render, staticRenderFns } from "./CandidateEdit.vue?vue&type=template&id=36d41d98"
import script from "./CandidateEdit.vue?vue&type=script&lang=js"
export * from "./CandidateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports